export default {
    methods: {
        onlyText(event) {
            if ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode === 39 || event.charCode === 45  || event.charCode === 32) {
                return true;
            } else {
                event.preventDefault();
            }
        },
        onlyNumbers(event) {
            if (event.charCode >= 48 && event.charCode <= 57) {
                return true;
            } else {
                event.preventDefault();
            }
        },
    }
};
